window.addEventListener('load', function() {
	var listboxes = document.querySelectorAll('.select-listbox');

	Array.prototype.forEach.call(listboxes, initListbox);

	var keyCode = {
		BACKSPACE: 8,
		TAB: 9,
		RETURN: 13,
		ESC: 27,
		SPACE: 32,
		PAGE_UP: 33,
		PAGE_DOWN: 34,
		END: 35,
		HOME: 36,
		LEFT: 37,
		UP: 38,
		RIGHT: 39,
		DOWN: 40,
		DELETE: 46
	};

	/**
	 * Adds a stylable listbox after the SELECT element. Screenreaders and user without JS will
	 * only see the SELECT element. Others will see the styled listbox.
	 * @param {HTMLElement} select
	 * @param {Number} index
	 */
	function initListbox(select, index) {
		var wrapper = document.createElement('div');
		wrapper.setAttribute('class', 'listbox-wrapper');
		wrapper.setAttribute('aria-hidden', 'true');
		var optionsHtml = '';
		var placeholder = ' ';
		var options = select.querySelectorAll('option');
		Array.prototype.forEach.call(options, function(option) {
			if (option.classList.contains('listbox-placeholder')) {
				placeholder = option.innerText;
				return;
			}
			optionsHtml += '<li role="option" data-value="' + (option.value || option.innerText) + '">' + option.innerText + '</li>';
		});

		var html =
			'<button type="button" class="listbox-button">' + placeholder + '</button>' +
			'<ul role="listbox">' +
				optionsHtml +
			'</ul>';

		wrapper.innerHTML = html;
		select.parentNode.insertBefore(wrapper, select.nextSibling);

		// Hide the original select
		select.classList.add('hidden-accessible');

		// Make the original select unfocusable
		select.setAttribute('tabindex', '-1');

		// Add a reference to the select to the listbox
		wrapper.select = select;

		// Add the listeners
		addListeners(wrapper);
	}

	/**
	 * Adds the event listeners to the listbox
	 * @param {HTMLElement} listboxWrapper
	 */
	function addListeners(listboxWrapper) {
		var button = listboxWrapper.querySelector('button');
		var list = listboxWrapper.querySelector('[role="listbox"]');
		var options = listboxWrapper.querySelectorAll('[role="option"]');
		var activeOptionIndex = -1;

		// Toggle the listbox when the listbox button is clicked
		button.addEventListener('click', function(e) {
			toggleListbox();
		});

		// Handler for the keydown event of the listbox button. Handles browsing
		// through the listbox with the UP and DOWN keys. Will close the
		// listbox when ESC is pressed.
		button.addEventListener('keydown', function(e) {
			var key = e.which || e.keyCode;
			switch (key) {
				case keyCode.DOWN:
					activeOptionIndex = ++activeOptionIndex % options.length;
					break;
				case keyCode.UP:
					activeOptionIndex = --activeOptionIndex;
					if (activeOptionIndex < 0) {
						activeOptionIndex = options.length - 1;
					}
					break;
				case keyCode.ESC:
					hideListbox();
					return;
			}

			if (activeOptionIndex >= 0) {
				activateOption(options[activeOptionIndex]);
			}
		});


		// Handler for the click event on the listbox. Will activate the option that
		// was clicked and hide the listbox.
		list.addEventListener('click', function(e) {
			var option = e.target;

			activeOptionIndex = Array.prototype.indexOf.call(options, option);
			activateOption(option);
			hideListbox();
		});

		// Hide the listbox when the button loses focus
		// Use focusin on the document because focusout on the button will
		// hides the listbox before a possible click can be handled.
		document.addEventListener('focusin', function(e) {
			if (e.target !== button) {
				hideListbox();
			}
		});

		// Add an handler for the click event on the document to close the listbox if the click
		// in anywhere outside the listbox.
		document.addEventListener('click', function(e) {
			if (e.target === button || Array.prototype.indexOf.call(options, e.target) >= 0) {
				return;
			}
			hideListbox();
		});

		/**
		 * Activates the given option. Sets the given option text in the listbox button.
		 * Removes the active-class from all other options and sets it on the given option.
		 * Sets the value of the original select to the options value.
		 *
		 * @param {HTMLElement} option
		 */
		function activateOption(option) {
			Array.prototype.forEach.call(options, function(o) {
				if (o === option) {
					o.classList.add('listbox-option-active');
				} else {
					o.classList.remove('listbox-option-active');
				}
			});
			listboxWrapper.select.value = option.getAttribute('data-value');
			button.innerText = option.innerText;
		}

		var DISPLAYCLASS = 'displayed';

		/**
		 * Shows the listbox by adding a class
		 */
		function showListbox() {
			list.classList.add(DISPLAYCLASS);
		}

		/**
		 * Hides the listbox by removing a class
		 */
		function hideListbox() {
			list.classList.remove(DISPLAYCLASS);
		}

		/**
		 * Toggles the listbox by adding or removing a class
		 */
		function toggleListbox() {
			list.classList.toggle(DISPLAYCLASS);
		}
	}
});
